
import { Component, Mixins } from "vue-property-decorator";
import { PrintBehavior } from "../../../../../../documaker/domain/format/objects";
import { IPrintBehaviorPropertyEditable, instanceOfIPrintBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class PrintBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IPrintBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IPrintBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isPrintBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIPrintBehaviorPropertyEditable(s) && s.printBehavior().isEditable(), false);
  }

  get printBehavior(): PrintBehavior {
    return this.readPropertyOrDefault(s => PrintBehavior.from(s.printBehavior().getValue()), new PrintBehavior(true, true));
  }

  set printBehavior(value: PrintBehavior) {
    this.writePropertyWhenValid(s => s.printBehavior().setValue(PrintBehavior.to(value)));
  }
}
